
import { defineComponent } from 'vue'
import api from '@/api/api'
import { store } from '@/store'
import { M_MENU } from '@/store/mutations-types'
import { columns } from '@/utils/columns'
import Grid from '@/components/Grid.vue'
import ModalCrud from '@/components/ModalCrud.vue'
import { formsValidations } from '@/utils/formsValidations';

export default defineComponent({
    name: 'CarrosManutencaoTipoView',
    components: {
        Grid,
        ModalCrud
    },
    data() {
        return {
            grid:{
                isLoading: false,
                columns: columns.cadastros.carrosManutencaoTipo,
                dataset: []
            },
            gridItemsActions: [
                {
                    label: 'Editar',
                    action: 'edit',
                    icon: 'mdi-pencil',
                    color: 'primary',
                    display: true,
                    loading: false
                }
            ],
            modals: {
                criarEditarTipo: {
                    isLoading: false,
                    visible: false,
                    title: '',
                }
            },
            forms: {
                criarEditarTipo: {
                    data: {
                        id: 0,
                        descricao: '',
                        obrigaKmAtual: false,
                        obrigaProximoServico: false,
                        avisaKmAntes: null,
                        avisaDiasAntes: null,
                        obrigaSolicitacao: false,
                        idStatus: false,
                    },
                    controls: {
                        isValid: true,
                        rules: formsValidations.requiredAndLength(50)
                    }
                }
            }
        }
    },
    methods:{
        loadDataGrid: async function () {
            try{
                this.grid.isLoading = true;
                const response = await api.get('/cars-maintenance-types');
                this.grid.dataset = response.data;
            }catch(error) {
                this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
            } finally {
                this.grid.isLoading = false;
            }
        },
        showModalNewEditTipo: async function(item) {
            try{
                this.modals.criarEditarTipo.title = item.id ? `${item.id} - Editar Tipo de Manutenção` : 'Novo Tipo de Manutenção';
                this.modals.criarEditarTipo.visible = true;
                this.modals.criarEditarTipo.isLoading = true;
                if(item.id){
                    const { data } = await api.get(`/cars-maintenance-types/${item.id}`);
                    this.forms.criarEditarTipo.data = {
                        id: data.id,
                        descricao: data.descricao,
                        obrigaKmAtual: data.obrigaKmAtual === 1,
                        obrigaProximoServico: data.obrigaProximoServico === 1,
                        avisaKmAntes: data.avisaKmAntes,
                        avisaDiasAntes: data.avisaDiasAntes,
                        obrigaSolicitacao: data.obrigaSolicitacao === 1,
                        idStatus: data.idStatus === 'A',
                    }
                }
            } catch(error) {
                this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
            } finally {
                this.modals.criarEditarTipo.isLoading = false;
            }
        },
        closeModalNewEditTipo: function() {
            this.modals.criarEditarTipo.visible = false;
            this.forms.criarEditarTipo.data = {
                id: 0,
                descricao: '',
                obrigaKmAtual: false,
                obrigaProximoServico: false,
                avisaKmAntes: null,
                avisaDiasAntes: null,
                obrigaSolicitacao: false,
                idStatus: false,
            }
        },
        saveTipo: async function() {
            try {
                if(this.$refs.form.validate()){
                    this.modals.criarEditarTipo.isLoading = true;
                    const [metodo, mensagem] = this.forms.criarEditarTipo.data.id ? ['put', 'alterado'] : ['post', 'criado'];
                    await api[metodo]('/cars-maintenance-types', this.forms.criarEditarTipo.data);
					this.$toast.success(`Tipo ${mensagem} com sucesso!`);
					this.closeModalNewEditTipo();
					this.loadDataGrid();
                }else {
                    this.$toast.warning('Formulário inválido! Verifique os dados.');
                }
            } catch(error) {
                this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
            } finally {
                this.modals.criarEditarTipo.isLoading = false;
            }
        },
        handleGridItemsActions: function(action: 'edit', item) {
            switch(action){
                case 'edit':
                    this.showModalNewEditTipo(item);
                    break;
                default:
                    this.$toast.error('Opção de ação inválida!');
            };
        },
    },
    async mounted() {
        store.commit(M_MENU, "Tipos - Manutenção de Carro");
        await this.loadDataGrid();
    }
})
